import { gql } from '@apollo/client'

export const UPLOAD_FILE_MUTATION = gql`
  mutation UploadObjectiveAttachment($file: Upload!, $employeeIdOfMeetingNotLoggedInEmployeeId: HashedId!) {
    uploadObjectiveAttachment(file: $file, employeeIdOfMeetingNotLoggedInEmployeeId: $employeeIdOfMeetingNotLoggedInEmployeeId)
  }
`
